import { DirectDebitInfo, PaymentStatus, } from '../models/entities';
import { PayButtonLevel } from '../models/payment';
import { hasPopMessage } from './promiseOfPaymentService';
import cloneDeep from 'lodash.clonedeep';
export const hasAtLeastOneOngoingDocument = (documents) => documents.some((document) => document.paymentStatus === PaymentStatus.ONGOING_PAYMENT ||
    isTransactionInOngoingDirectDebit(document));
export function isTransactionInOngoingDirectDebit(document) {
    var _a;
    return ((_a = document.paymentInfo) === null || _a === void 0 ? void 0 : _a.directDebitInfo) === DirectDebitInfo.ONGOING;
}
export function hasAnyOverdueTransactionWithOngoingDd(billingTransaction) {
    var _a, _b;
    return ((_b = (_a = billingTransaction.result) === null || _a === void 0 ? void 0 : _a.openTransactions.billingDocuments.some((document) => document.paymentStatus === PaymentStatus.OVERDUE &&
        isTransactionInOngoingDirectDebit(document))) !== null && _b !== void 0 ? _b : false);
}
export function areTransactionsInRefusedDirectDebit(openTransactions) {
    let softRefused = false;
    let hardRefused = false;
    openTransactions === null || openTransactions === void 0 ? void 0 : openTransactions.forEach((document) => {
        var _a, _b;
        if (((_a = document.paymentInfo) === null || _a === void 0 ? void 0 : _a.directDebitInfo) === DirectDebitInfo.HARDREFUSED) {
            hardRefused = true;
        }
        if (((_b = document.paymentInfo) === null || _b === void 0 ? void 0 : _b.directDebitInfo) === DirectDebitInfo.SOFTREFUSED) {
            softRefused = true;
        }
    });
    return { softRefused: softRefused && !hardRefused, hardRefused };
}
export const getTransactionRefs = (openTransactions, payButtonLevel, openTransactionToPay) => {
    const references = [];
    if (payButtonLevel === PayButtonLevel.transaction) {
        if (openTransactionToPay !== undefined) {
            references.push(openTransactionToPay.reference);
        }
    }
    else {
        openTransactions.forEach((openTransaction) => {
            if (shouldIncludeReference(openTransaction, payButtonLevel)) {
                references.push(openTransaction.reference);
            }
        });
    }
    return references;
};
const shouldIncludeReference = (billingDocument, paymentLevel) => {
    if (paymentLevel === PayButtonLevel.balancePOP) {
        return billingDocument.paymentStatus === PaymentStatus.OVERDUE;
    }
    return true;
};
export function filterImportantUnassignedFinancialTransactions(billingTransaction) {
    const clonedBillingTransaction = cloneDeep(billingTransaction);
    clonedBillingTransaction.openTransactions.unassignedFinancialTransactions =
        clonedBillingTransaction.openTransactions.unassignedFinancialTransactions.filter((unassignedFinancialTransaction) => unassignedFinancialTransaction.type === 'PAYMENT' &&
            Number(unassignedFinancialTransaction.amount) !== 0);
    return clonedBillingTransaction;
}
function hasAtLeastOneDocumentWithPaymentStatus(billingTransaction, status) {
    var _a, _b;
    return ((_b = (_a = billingTransaction.result) === null || _a === void 0 ? void 0 : _a.openTransactions.billingDocuments.some((document) => document.paymentStatus === status)) !== null && _b !== void 0 ? _b : false);
}
// TODO: not unit-tested
export function hasItemOngoing(billingTransaction) {
    return hasAtLeastOneDocumentWithPaymentStatus(billingTransaction, PaymentStatus.ONGOING_PAYMENT);
}
export function hasAnyOngoingPaymentTransaction(billingTransaction) {
    return hasItemOngoing(billingTransaction) || hasItemWithDirectDebitOngoing(billingTransaction);
}
export function areAllOpenTransactionsOngoing(billingTransactions) {
    const openTransactions = billingTransactions === null || billingTransactions === void 0 ? void 0 : billingTransactions.openTransactions.billingDocuments;
    return (openTransactions !== undefined &&
        openTransactions.length > 0 &&
        openTransactions.every((document) => {
            var _a;
            return document.paymentStatus === PaymentStatus.ONGOING_PAYMENT ||
                ((_a = document.paymentInfo) === null || _a === void 0 ? void 0 : _a.directDebitInfo) === DirectDebitInfo.ONGOING;
        }));
}
/**
 * This return true if one of the open transactions is in Hard Refused or Soft Refused,
 * @param billingTransaction The IEMData corresponding to the billingTransaction
 */
export function isRefusedDirectDebit(billingTransaction) {
    var _a;
    const openTransactions = (_a = billingTransaction.result) === null || _a === void 0 ? void 0 : _a.openTransactions.billingDocuments;
    if (openTransactions !== undefined) {
        const { softRefused, hardRefused } = areTransactionsInRefusedDirectDebit(openTransactions);
        return softRefused || hardRefused;
    }
    return false;
}
export function hasItemWithDirectDebitOngoing(billingTransaction) {
    var _a, _b;
    return ((_b = (_a = billingTransaction.result) === null || _a === void 0 ? void 0 : _a.openTransactions.billingDocuments.some((document) => { var _a; return ((_a = document.paymentInfo) === null || _a === void 0 ? void 0 : _a.directDebitInfo) === DirectDebitInfo.ONGOING; })) !== null && _b !== void 0 ? _b : false);
}
export function getPDFLinksAndDetails(document) {
    var _a;
    const documentType = (_a = document === null || document === void 0 ? void 0 : document.type) !== null && _a !== void 0 ? _a : '';
    switch (documentType) {
        case 'TELCO':
        case 'DN':
        case 'MC':
        case 'CN':
        case 'RET_TP':
        case 'NI2P':
            return { showPDFLink: true, showDetails: false };
        case 'REFUND':
        case 'AP':
        case 'PAYMENT':
        case 'CORR_CN':
        case 'CORR_DN':
        case 'IP':
            return { showPDFLink: false, showDetails: false };
        case 'BILL_TP':
        case 'BILL':
        case 'I2P':
        case 'I2P_TP':
            return { showPDFLink: true, showDetails: true };
        default:
            return { showPDFLink: false, showDetails: false };
    }
}
/**
 * Indicate if the refused direct debit message should be displayed
 * It should be if there is an overdue balance, or the transactions are in refused direct debit
 * @param billingTransaction
 * @param pop
 */
export function shouldDisplayRefusedDirectDebitMessage(billingTransaction, pop, language) {
    var _a;
    const openTransactions = (_a = billingTransaction.result) === null || _a === void 0 ? void 0 : _a.openTransactions.billingDocuments;
    const { softRefused, hardRefused } = areTransactionsInRefusedDirectDebit(openTransactions);
    return (softRefused || hardRefused) && !hasPopMessage(pop, language);
}
export function configureCard(document, translate) {
    var _a, _b;
    const Months = [
        translate('bills.months.january'),
        translate('bills.months.february'),
        translate('bills.months.march'),
        translate('bills.months.april'),
        translate('bills.months.may'),
        translate('bills.months.june'),
        translate('bills.months.july'),
        translate('bills.months.august'),
        translate('bills.months.september'),
        translate('bills.months.october'),
        translate('bills.months.november'),
        translate('bills.months.december'),
    ];
    const date = document.documentDate ? document.documentDate.split('/') : '';
    const title = `${Months[Number(date[1]) - 1]} ${date[2]}`;
    const subtitle = `${(_a = getDocumentTypeLabel(translate, document.type)) !== null && _a !== void 0 ? _a : ''} : ${document.reference}`;
    const newBill = document.paymentStatus === PaymentStatus.OPEN &&
        ((_b = document.paymentInfo) === null || _b === void 0 ? void 0 : _b.directDebitInfo) !== DirectDebitInfo.ONGOING;
    return { newBill, title, subtitle };
}
export function getDocumentTypeLabel(translate, documentType) {
    const DocumentTypeLabelTranslationKeys = new Map([
        ['TELCO', 'bills.billTypes.telco'],
        ['DN', 'bills.billTypes.dn'],
        ['MC', 'bills.billTypes.mc'],
        ['BILL_TP', 'bills.billTypes.billTp'],
        ['BILL', 'bills.billTypes.bill'],
        ['REFUND', 'bills.billTypes.refund'],
        ['CN', 'bills.billTypes.cn'],
        ['AP', 'bills.billTypes.ap'],
        ['PAYMENT', 'bills.billTypes.payment'],
        ['RET_TP', 'bills.billTypes.retTp'],
        ['I2P', 'bills.billTypes.i2p'],
        ['I2P_TP', 'bills.billTypes.i2pTp'],
        ['NI2P', 'bills.billTypes.ni2p'],
        ['CORR_CN', 'bills.billTypes.corrCn'],
        ['CORR_DN', 'bills.billTypes.corrDn'],
        ['IP', 'bills.billTypes.ip'], // Not used anymore
    ]);
    const documentTypeLabelTranslationKey = DocumentTypeLabelTranslationKeys.get(documentType);
    return documentTypeLabelTranslationKey ? translate(documentTypeLabelTranslationKey) : undefined;
}
